export default __webpack_public_path__ + "static/media/illustration-recruit-6-w.e996cf60.webp";